import logo from "../../../assets/fitoja-logo.jpg";
import maleProfilePic from "../../../assets/profile_pic_male.jpeg";
import closeIcon from "../../../assets/close_icon.png";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./track_orders.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface UserDetails {
  name: string;
  email: string;
  phoneNumber: string;
  role: string;
  gender: string;
}

interface Order {
  _id: string;
  phoneNumber: string;
  orders: Array<{
    deliveryAddress: {
      fullName: string;
      phoneNumber: number;
      addressLine1: string;
      city: string;
      state: string;
      pinCode: number;
    };
    totalPrice: number;
    isConfirmed: boolean;
    isDispatched: boolean;
    isOutForDelivery: boolean;
    isDelivered: boolean;
    _id: string;
    products: Array<{
      productName: string;
      category: string;
      productImage: string;
      selPrice: string;
      quantity: string;
    }>;
    orderPlacedAt: string;
  }>;
}

const TrackOrders: React.FC = () => {
  const [role, setRole] = useState<string>("");
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);
  const [showOverlay, setShowOverlay] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [orders, setOrders] = useState<Order[]>([]);
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [openChangeOrderStatus, setOpenChangeOrderStatus] = useState(false);
  const [
    changeOrderStatusOrderDispatched,
    setChangeOrderStatusOrderDispatched,
  ] = useState(false);
  const [changeOrderStatusOutForDelivery, setChangeOrderStatusOutForDelivery] =
    useState(false);
  const [changeOrderStatusDelivered, setChangeOrderStatusDelivered] =
    useState(false);
  const [selectedDispatchedDate, setSelectedDispatchedDate] = useState(null);
  const [selectedOutForDeliveryDate, setSelectedOutForDeliveryDate] =
    useState(null);
  const [selectedDeliveredDate, setSelectedDeliveredDate] = useState(null);
  const [shippingPartner, setShippingPartner] = useState("");
  const [trackingId, setTrackingId] = useState("");
  const [deliveryPartner, setDeliveryPartner] = useState("");
  const [orderId, setOrderId] = useState("");

  const navigate = useNavigate();
  const isInitialRender = useRef(true);

  const fetchUserDetails = async () => {
    try {
      const email = localStorage.getItem("email");
      const token = localStorage.getItem("token");

      if (!email || !token) {
        navigate("/login");
        return;
      }

      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.get(
        `https://api.fitoja.in/api/get-employee-details/${email}`,
        config
      );

      setUserDetails(response.data);
      setRole(response.data.role);
      fetchAllOrders();
    } catch (error) {
      handleLogout();
    }
  };

  const fetchAllOrders = async () => {
    try {
      const response = await axios.get(
        `https://api.fitoja.in/api/get-all-orders`
      );
      setOrders(response.data.orders); // Save orders to state
      if (response.status == 200) {
        setOpenChangeOrderStatus(false);
        setChangeOrderStatusOrderDispatched(false);
        setOpenChangeOrderStatus(false);
        setChangeOrderStatusOutForDelivery(false);
        setOpenChangeOrderStatus(false);
        setChangeOrderStatusDelivered(false);
      }
    } catch (error) {
      console.error("Failed to fetch orders:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateOrderStatus = async (
    phoneNumber,
    orderId,
    isConfirmed,
    isDispatched,
    isOutForDelivery,
    isDelivered,
    orderDispatchedAt,
    shippingPartner,
    trackingId,
    orderOutForDeliverAt,
    deliveryPartner,
    deliveryPartnerContactNumber,
    deliveredAt
  ) => {
    try {
      const response = await axios.post(
        `https://api.fitoja.in/api/update-order-status/${phoneNumber}`,
        {
          orderId,
          isConfirmed,
          isDispatched,
          isOutForDelivery,
          isDelivered,
          orderDispatchedAt,
          shippingPartner,
          trackingId,
          orderOutForDeliverAt,
          deliveryPartner,
          deliveryPartnerContactNumber,
          deliveredAt,
        }
      );

      if (response.status == 200) {
        fetchAllOrders();
      }

      console.log("Status updated:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error updating order status:",
        error.response?.data || error.message
      );
      throw error;
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    navigate("/login");
  };

  const openOrderDetails = (order: Order) => {
    setSelectedOrder(order);
  };

  const closeOrderDetails = () => {
    setSelectedOrder(null);
  };

  useEffect(() => {
    if (isInitialRender.current) {
      fetchUserDetails();
      isInitialRender.current = false;
    }
  }, []);

  return (
    <div className="track_orders-container">
      {loading && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading, please wait...</p>
        </div>
      )}

      {!loading && (
        <>
          <header className="track_orders-header">
            <div
              className="logo"
              onClick={() => navigate("/e-commerce-portal")}
            >
              <img src={logo} />
            </div>
            <div
              className="profile-section"
              onClick={() => setShowOverlay(!showOverlay)}
            >
              <img className="profile-pic" src={maleProfilePic} alt="Profile" />
            </div>
          </header>

          {showOverlay && userDetails && (
            <div className="profile-overlay">
              <div className="overlay-content">
                <img
                  className="close_icon"
                  onClick={() => setShowOverlay(false)}
                  src={closeIcon}
                />
                <p>
                  <strong>Name:</strong> {userDetails.name}
                </p>
                <p>
                  <strong>Email:</strong> {userDetails.email}
                </p>
                <p>
                  <strong>Phone Number:</strong> {userDetails.phoneNumber}
                </p>
                <p>
                  <strong>Role:</strong> {userDetails.role}
                </p>
                <p>
                  <strong>Gender:</strong> {userDetails.gender}
                </p>
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          )}

          <br></br>
          <br></br>
          <br></br>
          <br></br>

          <h1>Track Order</h1>

          <div className="orders-list">
            {orders.map((order) => (
              <div
                key={order._id}
                className="order-card"
                onClick={() => openOrderDetails(order)}
              >
                <p>
                  <strong>Phone Number:</strong> {order.phoneNumber}
                </p>
                <p>
                  <strong>Total Orders:</strong> {order.orders.length}
                </p>
              </div>
            ))}
          </div>

          {selectedOrder && (
            <div className="order-details-popup">
              <div className="popup-content">
                <img
                  className="close_icon"
                  src={closeIcon}
                  onClick={closeOrderDetails}
                />
                <h2>Orders for {selectedOrder.phoneNumber}</h2>
                {selectedOrder.orders.map((orderDetail) => (
                  <div
                    key={orderDetail.orderPlacedAt}
                    className="order-detail-card"
                    onClick={() => {
                      setOpenChangeOrderStatus(true);
                    }}
                  >
                    {!orderDetail.isDispatched && (
                      <span
                        onClick={() => {
                          setChangeOrderStatusOrderDispatched(true);
                          setOrderId(orderDetail._id);
                        }}
                        className="order-status-confirmed"
                      >
                        Order Placed
                      </span>
                    )}
                    {!orderDetail.isOutForDelivery &&
                      orderDetail.isDispatched && (
                        <span
                          onClick={() => {
                            setChangeOrderStatusOutForDelivery(true);
                            setOrderId(orderDetail._id);
                          }}
                          className="order-status-dispatched"
                        >
                          Order Dispatched
                        </span>
                      )}
                    {!orderDetail.isDelivered &&
                      orderDetail.isOutForDelivery && (
                        <span
                          onClick={() => {
                            setChangeOrderStatusDelivered(true);
                            setOrderId(orderDetail._id);
                          }}
                          className="order-status-out-for-delivery"
                        >
                          Out for Delivery
                        </span>
                      )}
                    {orderDetail.isDelivered && (
                      <span className="order-status-delivered">Delivered</span>
                    )}
                    <p>
                      <strong>Recipient:</strong>{" "}
                      {orderDetail.deliveryAddress.fullName}
                    </p>

                    <p>
                      <strong>Address:</strong>{" "}
                      {orderDetail.deliveryAddress.addressLine1},{" "}
                      {orderDetail.deliveryAddress.city}
                    </p>
                    <p>
                      <strong>Total Price:</strong> ₹{orderDetail.totalPrice}
                    </p>
                    <h4>Products:</h4>
                    <div style={{ display: "flex", gap: "10px" }}>
                      {orderDetail.products.map((product) => (
                        <div key={product.productName} className="product-card">
                          <img
                            src={product.productImage}
                            alt={product.productName}
                          />
                          <p>
                            <strong>{product.productName}</strong>
                          </p>
                          <p>Price: ₹{product.selPrice}</p>
                          <p>Quantity: {product.quantity}</p>
                        </div>
                      ))}
                    </div>
                    {openChangeOrderStatus &&
                      changeOrderStatusOrderDispatched && (
                        <div className="change-order-status">
                          <div className="change-order-status__container">
                            <img
                              className="close_icon"
                              src={closeIcon}
                              onClick={() => {
                                setOpenChangeOrderStatus(false);
                                setChangeOrderStatusOrderDispatched(false);
                              }}
                              alt="Close"
                            />
                            <h3>Change order status:</h3>
                            <input
                              value={shippingPartner}
                              onChange={(e) =>
                                setShippingPartner(e.target.value)
                              }
                              placeholder="Shipping Partner name"
                            />
                            <DatePicker
                              selected={selectedDispatchedDate}
                              onChange={(date: any) =>
                                setSelectedDispatchedDate(date)
                              }
                              showTimeSelect
                              dateFormat="Pp"
                              placeholderText="Dispatched timing"
                            />
                            <input
                              value={trackingId}
                              onChange={(e) => setTrackingId(e.target.value)}
                              placeholder="Enter Tracking ID"
                            />
                            <span
                              style={{ marginBottom: "0px" }}
                              onClick={async () => {
                                updateOrderStatus(
                                  selectedOrder.phoneNumber,
                                  orderId,
                                  true,
                                  true,
                                  false,
                                  false,
                                  selectedDispatchedDate,
                                  shippingPartner,
                                  trackingId,
                                  null,
                                  null,
                                  null,
                                  null
                                );
                              }}
                              className="order-status-dispatched"
                            >
                              Order Dispatched
                            </span>
                          </div>
                        </div>
                      )}
                    {openChangeOrderStatus &&
                      changeOrderStatusOutForDelivery && (
                        <div className="change-order-status">
                          <div className="change-order-status__container">
                            <img
                              className="close_icon"
                              src={closeIcon}
                              onClick={() => {
                                setOpenChangeOrderStatus(false);
                                setChangeOrderStatusOutForDelivery(false);
                              }}
                            />
                            <h3>Change order status:</h3>
                            <input placeholder="Delivery Partner name" />
                            <DatePicker
                              selected={selectedOutForDeliveryDate}
                              onChange={(date: any) =>
                                setSelectedOutForDeliveryDate(date)
                              }
                              showTimeSelect
                              dateFormat="Pp"
                              placeholderText="Out for delivery timing"
                            />
                            <input placeholder="Delivery Partner Contact number" />
                            <span
                              style={{ marginBottom: "0px" }}
                              onClick={() => {
                                setChangeOrderStatusDelivered(true);
                              }}
                              className="order-status-out-for-delivery"
                            >
                              Out for Delivery
                            </span>
                          </div>
                        </div>
                      )}
                    {openChangeOrderStatus && changeOrderStatusDelivered && (
                      <div className="change-order-status">
                        <div className="change-order-status__container">
                          <img
                            className="close_icon"
                            src={closeIcon}
                            onClick={() => {
                              setOpenChangeOrderStatus(false);
                              setChangeOrderStatusDelivered(false);
                            }}
                          />
                          <h3>Change order status:</h3>
                          <DatePicker
                            selected={selectedDeliveredDate}
                            onChange={(date: any) =>
                              setSelectedDeliveredDate(date)
                            }
                            showTimeSelect
                            dateFormat="Pp"
                            placeholderText="Delivery timing"
                          />
                          <span
                            style={{ marginBottom: "0px" }}
                            onClick={() => {
                              // setChangeOrderStatusDelivered(true);
                            }}
                            className="order-status-delivered"
                          >
                            Delivered
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TrackOrders;
